import React from 'react';
import { motion } from 'framer-motion';

interface Props {
  sectionVariants: any;
  itemVariants: any;
}

export const FoundersSection: React.FC<Props> = ({ sectionVariants, itemVariants }) => {
  return (
    <motion.section
      className="py-28 md:py-36 px-6 md:px-12 bg-white border-t border-ink-line"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.15 }}
      variants={sectionVariants}
    >
      <div className="max-w-7xl mx-auto">
        <div className="max-w-3xl mb-20">
          <motion.p
            className="text-xs uppercase tracking-eyebrow text-ink-muted mb-8"
            variants={itemVariants}
          >
            The Founders
          </motion.p>
          <motion.h2
            className="font-display text-4xl md:text-6xl leading-tight tracking-tight mb-10"
            variants={itemVariants}
          >
            Built by <span className="italic">two founders.</span>
          </motion.h2>
          <motion.p
            className="text-xl md:text-2xl text-ink leading-relaxed"
            variants={itemVariants}
          >
            David and Tamara McKinney co-founded TND Labs to build businesses together, bringing
            different perspectives and strengths to every venture.
          </motion.p>
        </div>

        <div className="grid md:grid-cols-2 border-t border-l border-ink-line">
          <motion.div className="p-8 md:p-12 border-r border-b border-ink-line" variants={itemVariants}>
            <div className="w-12 h-12 rounded-full bg-ink text-white flex items-center justify-center font-display text-lg mb-8">
              D
            </div>
            <h3 className="font-display text-3xl mb-2">David McKinney</h3>
            <p className="text-[11px] uppercase tracking-eyebrow text-ink-muted mb-8">
              Co-Founder &middot; Technology &amp; Venture Development
            </p>
            <p className="text-ink-soft leading-relaxed mb-5">
              David is an engineer who applies systems thinking to entrepreneurship: understand the
              system, identify the constraint, develop a thesis, build, measure, and iterate. That
              approach holds whether the venture is software, a physical product, construction, or
              something else entirely.
            </p>
            <p className="text-ink-soft leading-relaxed">
              Beyond TND Labs' technology ventures, he partners with Tamara across the portfolio,
              bringing that same discipline to decisions well outside software.
            </p>
          </motion.div>

          <motion.div className="p-8 md:p-12 border-r border-b border-ink-line" variants={itemVariants}>
            <div className="w-12 h-12 rounded-full bg-venture-measure text-white flex items-center justify-center font-display text-lg mb-8">
              T
            </div>
            <h3 className="font-display text-3xl mb-2">Tamara McKinney</h3>
            <p className="text-[11px] uppercase tracking-eyebrow text-ink-muted mb-8">
              Co-Founder &middot; Principal, True Measure
            </p>
            <p className="text-ink-soft leading-relaxed mb-5">
              Tamara is Principal of True Measure, TND Labs' construction venture, where she brings
              the same discipline to the business that David brings to engineering: exacting
              attention to detail and clear, logical thinking applied to every decision.
            </p>
            <p className="text-ink-soft leading-relaxed">
              Beyond True Measure, she partners with David across the portfolio, bringing that same
              precision to decisions well outside construction.
            </p>
          </motion.div>
        </div>
      </div>
    </motion.section>
  );
};

export default FoundersSection;
